import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { showMessage } from 'app/store/fuse/messageSlice';
import { http } from 'lib';

const initialState = {
	searchTerm: '',
	page: 0,
	rowsPerPage: 10,
	orderBy: 'createdAt',
	order: 'desc',
	earlySignupUser: {
		response: {},
		loading: false,
		error: ''
	}
};

const earlySignupSlice = createSlice({
	name: 'user/early-signup',
	initialState,
	reducers: {
		setSearchTerm: (state, { payload }) => {
			state.searchTerm = payload;
		},
		setPage: (state, { payload }) => {
			state.page = payload;
		},
		setRowsPerPage: (state, { payload }) => {
			state.rowsPerPage = payload;
		},
		setOrderBy: (state, { payload }) => {
			state.orderBy = payload;
		},
		setOrder: (state, { payload }) => {
			state.order = payload;
		},
		getEarlySignupUserBegin: state => {
			state.earlySignupUser.loading = true;
		},
		getEarlySignupUserSuccess: (state, { payload }) => {
			state.earlySignupUser.loading = false;
			state.earlySignupUser.response = payload;
		},
		getEarlySignupUserFailure: (state, { payload }) => {
			state.earlySignupUser.loading = false;
			state.earlySignupUser.error = payload;
		},
		resetState: () => ({
			...initialState
		})
	}
});

export const {
	setSearchTerm,
	setPage,
	setRowsPerPage,
	setOrderBy,
	setOrder,
	getEarlySignupUserBegin,
	getEarlySignupUserFailure,
	getEarlySignupUserSuccess,
	resetState
} = earlySignupSlice.actions;

export const getEarlySignupUser = createAsyncThunk('document/get-early-access-user', async (params, { dispatch }) => {
	dispatch(getEarlySignupUserBegin());
	try {
		const { data } = await http({
			url: '/early-access/signup',
			options: { params },
			token: true,
			service: 'cms'
		});
		dispatch(getEarlySignupUserSuccess(data));
	} catch (error) {
		dispatch(getEarlySignupUserFailure(error?.response?.data?.message));
		dispatch(
			showMessage({
				message: error?.response?.data?.message,
				variant: 'error'
			})
		);
	}
});

export default earlySignupSlice.reducer;
